module.exports = __webpack_public_path__ + "static/screen-day-2-1b93ea26364f9a6a4be364c4f12023fc.png";